import { StyleSheet } from 'react-native'

const card = {
  backgroundColor: '#fff',
  borderRadius: 10,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.08,
  shadowRadius: 4,
  elevation: 2
}

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f3f4f8'
  },
  header: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center'
  },
  headerText: {
    color: '#fff',
    fontWeight: '600',
    fontSize: 15,
    textTransform: 'uppercase',
    letterSpacing: 1,
    textAlign: 'center'
  },
  printButton: {
    position: 'absolute',
    right: 12,
    top: 6
  },
  scrollContent: {
    padding: 16,
    gap: 14
  },
  kpiRow: {
    flexDirection: 'row',
    gap: 10,
    flexWrap: 'wrap'
  },
  kpiCard: {
    ...card,
    flex: 1,
    minWidth: 130,
    padding: 18,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    borderTopWidth: 3
  },
  kpiLabel: {
    fontSize: 11,
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  kpiValue: {
    fontSize: 32,
    fontWeight: '700'
  },
  filterCard: {
    ...card,
    padding: 16,
    gap: 10
  },
  filterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap'
  },
  dateInput: {
    flex: 1,
    minWidth: 150
  },
  filterSep: {
    color: '#888',
    fontSize: 13,
    paddingHorizontal: 2
  },
  buscarBtn: {
    minWidth: 100
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 6
  },
  mainRow: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'flex-start'
  },
  tableCard: {
    ...card,
    flex: 2,
    padding: 14,
    gap: 4,
    minWidth: 320
  },
  tableWrapper: {
    borderRadius: 6,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#e5e7eb'
  },
  tableHeader: {
    flexDirection: 'row',
    paddingVertical: 10,
    paddingHorizontal: 10
  },
  tableHeaderText: {
    color: '#fff',
    fontWeight: '700',
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.3
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#ededf0'
  },
  tableCell: {
    fontSize: 13,
    color: '#333'
  },
  colCodigo: { width: 72 },
  colCliente: { flex: 1 },
  colData: { width: 165 },
  sideCard: {
    ...card,
    flex: 1,
    padding: 14,
    gap: 8,
    minWidth: 240
  },
  sideScroll: {
    maxHeight: 540
  },
  clientCard: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderLeftWidth: 3,
    borderBottomWidth: 1,
    borderBottomColor: '#ededf0',
    gap: 3,
    backgroundColor: '#fff'
  },
  clientName: {
    fontSize: 12,
    fontWeight: '600',
    color: '#333',
    flex: 1,
    marginRight: 8
  },
  clientSub: {
    fontSize: 11,
    color: '#888'
  },
  badge: {
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
    minWidth: 28,
    alignItems: 'center'
  },
  badgeText: {
    color: '#fff',
    fontSize: 11,
    fontWeight: '700'
  },
  emptyText: {
    padding: 16,
    textAlign: 'center',
    color: '#999',
    fontSize: 13
  }
})


